import filteringUtility from './utils';
var DropdownHandler = /** @class */ (function () {
    function DropdownHandler() {
    }
    DropdownHandler.prototype.__generateProperties = function (filteringOptions, groupPropertiesText) {
        return {
            label: groupPropertiesText,
            options: filteringOptions.map(function (option) { return ({
                group: 'property',
                groupValuesLabel: option.groupValuesLabel,
                label: option.propertyLabel,
                propertyLabel: option.propertyLabel,
                propertyKey: option.propertyKey,
                value: option.propertyLabel
            }); })
        };
    };
    DropdownHandler.prototype.__generateValues = function (currentProperty, filteringOptions, tokens, groupValuesText) {
        var label = currentProperty ? currentProperty.groupValuesLabel : groupValuesText;
        var tokenValueSet = tokens.reduce(function (acc, token) {
            if (token.propertyKey) {
                acc[token.propertyKey] = acc[token.propertyKey] || {};
                acc[token.propertyKey][token.value] = true;
            }
            return acc;
        }, {});
        var transformToAutosuggest = function (item) {
            var uniqueValues = new Set(item.values);
            var usedValues = item.propertyKey ? tokenValueSet[item.propertyKey] || {} : {};
            var items = [];
            uniqueValues.forEach(function (value) {
                value = String(value);
                items.push({
                    __labelPrefix: filteringUtility.getPropertyPrefixFormat(item.propertyLabel),
                    disabled: !!usedValues[value],
                    group: 'value',
                    groupValuesLabel: item.groupValuesLabel,
                    propertyLabel: item.propertyLabel,
                    propertyKey: item.propertyKey,
                    label: "" + (value || '-'),
                    value: value
                });
            });
            return items;
        };
        var valueOptions = currentProperty
            ? filteringOptions.filter(function (option) { return option.propertyKey === currentProperty.propertyKey; })
            : filteringOptions;
        var options = valueOptions.map(transformToAutosuggest).reduce(function (acc, values) { return acc.concat(values); }, []);
        return {
            label: label,
            options: options
        };
    };
    DropdownHandler.prototype.__filterOptions = function (options, filteringText, currentProperty) {
        if (currentProperty) {
            var filteringTextValueWithoutProperty = filteringText.substring(filteringUtility.getPropertyPrefixFormat(currentProperty.label).length);
            return filteringUtility.filterOptions(options, filteringTextValueWithoutProperty);
        }
        return filteringUtility.filterOptions(options, filteringText);
    };
    DropdownHandler.prototype.__groupOptions = function (filteringOptions, groupPropertiesText, groupValuesText, customGroupsText) {
        var defaultGroup = {
            propertiesText: groupPropertiesText,
            valuesText: groupValuesText,
            options: []
        };
        var customGroupsIndex = {};
        var groups = [defaultGroup];
        var _loop_1 = function (option) {
            if (option.group) {
                if (!customGroupsIndex[option.group]) {
                    var groupText = customGroupsText.filter(function (_a) {
                        var group = _a.group;
                        return group === option.group;
                    })[0];
                    customGroupsIndex[option.group] = {
                        propertiesText: groupText && groupText.properties,
                        valuesText: groupText && groupText.values,
                        options: []
                    };
                    groups.push(customGroupsIndex[option.group]);
                }
                customGroupsIndex[option.group].options.push(option);
            }
            else {
                defaultGroup.options.push(option);
            }
        };
        for (var _i = 0, filteringOptions_1 = filteringOptions; _i < filteringOptions_1.length; _i++) {
            var option = filteringOptions_1[_i];
            _loop_1(option);
        }
        return groups;
    };
    DropdownHandler.prototype.generateOptions = function (filteringOptions, filteringText, tokens, currentProperty, groupPropertiesText, groupValuesText, customGroupsText, disableDefaultFiltering) {
        var optionsGroups = this.__groupOptions(filteringOptions, groupPropertiesText, groupValuesText, customGroupsText);
        var options = [];
        if (!currentProperty) {
            for (var _i = 0, optionsGroups_1 = optionsGroups; _i < optionsGroups_1.length; _i++) {
                var group = optionsGroups_1[_i];
                options.push(this.__generateProperties(group.options, group.propertiesText));
            }
        }
        if (filteringText || currentProperty) {
            for (var _a = 0, optionsGroups_2 = optionsGroups; _a < optionsGroups_2.length; _a++) {
                var group = optionsGroups_2[_a];
                options.push(this.__generateValues(currentProperty, group.options, tokens, group.valuesText));
            }
        }
        if (disableDefaultFiltering) {
            return options;
        }
        return this.__filterOptions(options, filteringText, currentProperty);
    };
    return DropdownHandler;
}());
export default DropdownHandler;
//# sourceMappingURL=dropdown-handler.js.map